/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-03-18 11:29:54
 */
export default {
  lang: "英语",
  landing: {
    name1: "Open Carlcare",
    name2: "Reservation now",
    name3: "With Carlcare, you can check your order at any time.",
    name4: "Verification code",
    name5: "Slide to the right",
    name6: "Verification complete",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "Enjoy Carlcare Battery Replacement Service !", // 标题
    name10: "Enjoy an original battery replacement service for designated Infinix/Tecno/itel models, now available at Up to 50% off!",
    name11: "- Battery prices vary by model. Please check the updated price list below for more details.",
    name12: 'The battery price may vary depending on the model. Please refer to the price list below for details.', // 小字标注
    name13: "Why Choose Carlcare Battery Replacement ?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name18: "3-Month Warranty",
    name19: "Get a 3-month official warranty for your new battery.",
    name20: "Lower and Affordable Price",
    name21: "Get a great discount on battery prices.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for battery replacements only and is limited to specific models.",
    name27: "3. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name28: "4. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare Hotline at: 07080632363.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the final right to interpret this promotion.For inquiries or assistance, please call Carlcare hotline at 02-8705-4200.",
    name31: "Carlcare Service Statements:",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "Starting from ₱500",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
    name40: "Original Battery",
    name41: "Affordable Price",
    name42: "Free Labor Fee",
  },
  order: {
    name1: "Cihaz modelini seçin",
    name2: "Arıza Açıklaması:",
    name3: "Servis mağazasını seçmek için dokunun",
    name4: "Servis Mağazası:",
    name5: "Rezervasyon Saati:",
    name6: "Lütfen cihazınızın sorununu detaylı olarak açıklayın!",
    name7: "Varış saatini seçmek için dokunun",
    name8: "Lütfen size ulaşabileceğimiz doğru iletişim detaylarınızı girin",
    name9: "Mevcut rezervasyon saati aşağıdaki gibidir",
    name10: "Lütfen telefon numaranızı girin",
    name11: "Fiyat",
    name12: "Kişisel bilgi:",
    name13: "Lütfen adınızı girin",
    name14: "Gönder",
    name15: "İptal et",
    name16: "TAMAM",
  },
  shops: {
    name1: "Seçtiğiniz markaya göre, aşağıdaki mağazalar size hizmet verebilir!",
    name2: "Çok yakında daha fazla perakende mağazasıyla hizmetinizdeyiz! Bizi izlemeye devam edin!",
  },
  price: {
    name1: "Marka",
    name2: "Model",
    name3: "ÖĞE",
    name4: "Fiyat",
    name5: "Yardımcı Anımsatıcı:",
    name6: "Bu fiyatlar sadece bilgilendirme amaçlı olup, gerçek fiyat cihazınızın durumuna göre değişiklik gösterir.",
    name7: "Herhangi bir özel simge yoksa, fiyat birimi yerel para birimidir.",
    name8: "Üzgünüz! Geçerli bölgede kullanılabilir fiyat bilgisi yok.",
    name11:"İşçilik Maliyeti",
    name12:"Toplam Fiyat",
    name13: "5. İşçilik maliyeti \"/\" ise işçilik maliyetinin mağazayla görüşülmesi isteniyor.",
    item_main_board: "Ana Kart",
    item_screen_frame: "Ekran (Çerçeve)",
    item_screen_screen_frame: "İkinci Ekran (Çerçeve)",
    item_touch_screen: "Dokunmatik Ekran",
    item_camera: "Kamera",
    item_fixed_focus_camera: "Sabit Odaklı Kamera",
    item_auto_focus_camera: "Otomatik Odaklı Kamera",
    item_screen: "Ekran",
    item_secondary_screen: "İkinci Ekran",
    item_fingerprint_module: "Parmak İzi Modülü",
    item_speaker: "Hoparlör",
    item_receiver: "Alıcı",
    item_small_board: "Küçük Pano",
    item_battery_cover: "Batarya Kapağı",
    item_battery: "Batarya",
    item_charger: "Şarj Cihazı",
    item_usb_cable: "USB Kablosu",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "Veri yok",
    name2: "Servis Sağlayıcısı:",
    name3: "Hizmet Markası:",
    name4: "Telefon:",
    name5: "Siparişin Miktarı:",
    name6: "Servis Derecesi",
    name7: "Servis Ortamı:",
    name8: "Servis Yaklaşımı:",
    name9: "Servis Verimliliği:",
    name10: "Servis Kalitesi:",
    name11: "Müşteri Değerlendirmesi",
    name12:"kime",
    name13:"Kapalı",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare\'i aç",
    name1: "Öncelikli hizmete erişmek için lütfen rezervasyon bilgisinin ekran görüntüsünü alın ve fiş olarak kaydedin.",
    name2: "Başarıyla gönderildi",
    name3: "1. Verileri temizleyin",
    name4: "Telefonunuzdaki önemli özel verileri lütfen önceden yedekleyin",
    name5: "2. Güç açma parolasını devre dışı bırak",
    name6: "Servis mağazasına gitmeden önce lütfen şunları yapın",
    name7: "Servis Mağazası",
    name8: "Rezervasyon Saati",
    name9: "Arıza Açıklaması",
    name10: "Cihaz Modeli",
    name11: "Sipariş Numarası",
    name12: "Sipariş Bilgisi",
  },
  title: {
    
    name1: "Aşağıdaki ülkeleri destekler:",
    name2: "Model Seçin",
    name3: "Rezervasyon",
    name4: "Servis Mağazası Detayları",
    name5: "Servis Mağazasını Seçin",
  },
  error: {
    
    name1: "Veri yok. Lütfen onarım bilginizi kontrol edin",
    name2: "Daha fazla yardıma mı ihtiyacınız var? Lütfen bizimle iletişime geçin.",
    name3: "Üzgünüz, mevcut bölgede Carlcare merkezi yok.",
    name4: "Lütfen önce bir servis merkezi seçin",
    name5: "Başarısız oldu",
    name6: "Lütfen önce cihaz modelini seçin",
    name7: "Detaylar",
    name8: "Lütfen ihtiyaçlarınızı ayrıntılı olarak açıklayın",
    name9: "",
  },
  add1:{
    "name0": "tr",
    "name1": "Siparişiniz onaylandı. Varışınızı sabırsızlıkla bekliyoruz.",
    "name2": "Şehri seçin",
    "name3": "Lütfen %1$s haneli bir telefon numarası girin.",
    "name4": "Hafta İçi Saatler",
    "name5": "Pazartesi",
    "name6": "Salı",
    "name7": "Çarşamba",
    "name8": "Perşembe",
    "name9": "Cuma",
    "name10": "Cumartesi",
    "name11": "Pazar",
    "name12": "Ülke gir ve ara"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "Diğerleri",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"Yönlendirme için Dokunun",
    name3:"Siparişinizi değerlendirmek için Carlcare uygulamasını açın",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"Servis Seçin",
    name7:"Ücretsiz Temizlik",
    name8:"Yazılım Yükseltme",
  },
  cancelorder:{
    "cancelReason0": "Hatalı bilgi",
    "cancelReason1": "Zamanında ulaşamaz",
    "cancelReason2": "Mükerrer sipariş/benim siparişim değil",
    "cancelReason3": "Arıza tekrarlamıyor",
    "cancelReason4": "Sadece test/sorgu/etkinlik/… için",
    "cancelReason5": "Yüksek fiyat",
    "cancelReason6": "Malzeme sıkıntısı",
    "cancelReason7": "Ayrıştırılmış hizmet yok",
    "cancelReason8": "Mağaza çok uzak",
    "cancelReason9": "Mağaza kapalı",
    "cancelReason10": "Kötü hizmet tavrı",
    "cancelReason11": "Diğer markalar için değiştirme/onarım",
    "cancelReason12": "Mağazayı bulunamıyor",
    "cancelReason13": "Diğer",
    "cancelOrder": "Siparişi İptal Et",
    "reason_dialog_title": "Lütfen iptal etme nedeninizi söyleyin",
    "Cancel": "İptal et",
    "OK": "TAMAM",
    "name1": "Doğrulama kodunu girin",
    "name2": "Geçersiz doğrulama kodu",
    "repair_reservation_detail_canceled": "Bu sipariş İptal Edildi!",
    "purchase_cancel_dialog_content": "Siparişinizi iptal etmeyi onaylıyor musunuz?",
    "yes": "Evet",
    "no": "Hayır"
}
};
